import { useState } from "react";
import { Col, Form, Row } from "react-bootstrap";
import Swal from "sweetalert2";
import { postRequestByAuth } from "../../../../function/helper";

function NewTicket() {
  const rawForm = {
    sectionSupport: "پشتیبانی",
    typeSupport: "سفارش خاص",
    prioritySupport: "کم",
    subjectSupport: "",
    barnameSupport: "",
    descSupport: "",
  };

  const [formSupport, setFormSupport] = useState(rawForm);
  const [errorsSupport, setErrorsSupport] = useState({});
  const [loading, setLoading] = useState(false);
  const [getValue, setGetValue] = useState("سفارش خاص");

  const setFieldSupport = (field, value) => {
    setFormSupport({ ...formSupport, [field]: value });
    if (errorsSupport[field]) {
      setErrorsSupport({ ...errorsSupport, [field]: null });
    }
  };

  const findErrorsSupport = () => {
    const { typeSupport, barnameSupport, subjectSupport, descSupport } =
      formSupport;
    const newErrors = {};
    if (typeSupport === "سفارش خاص") {
      if (!barnameSupport) {
        newErrors.barnameSupport = "شماره بارنامه الزامی است";
      }
    }

    if (!subjectSupport) {
      newErrors.subjectSupport = "موضوع تیکت مشخص نشده است";
    }

    if (!descSupport) {
      newErrors.descSupport = "شرح تیکت مشخص نشده است";
    }
    return newErrors;
  };

  const supportRequest = async () => {
    const body = {
      importance: formSupport.prioritySupport,
      Handlingunit: formSupport.sectionSupport,
      typeTicket: formSupport.typeSupport,
      partnumber: formSupport.partSupport,
      numberParcel: formSupport.barnameSupport,
      subject: formSupport.subjectSupport,
      message: formSupport.descSupport,
    };

    setLoading(true);
    const response = await postRequestByAuth("/setting/v1/ticket/add", body);
    setLoading(false);

    if (response.status === 200) {
      setFormSupport(rawForm);

      Swal.fire({
        icon: "success",
        title: "با موفقیت ارسال شد",
        showCloseButton: false,
        confirmButtonText: "بستن",
      });
    } else {
      Swal.fire({
        icon: "error",
        title: response.data.message ?? "خطای ارتباط با سرور",
        showCloseButton: false,
      });
    }
  };

  const handleSupport = e => {
    e.preventDefault();
    const newError = findErrorsSupport();
    if (Object.keys(newError).length > 0) {
      setErrorsSupport(newError);
    } else {
      supportRequest();
    }
  };

  return (
    <div dir="rtl">
      <h4 className="text-secondary">ارسال تیکت جدید</h4>
      <hr />
      <Form onSubmit={handleSupport}>
        <Form.Group>
          <Row>
            <Col lg={6} md={6} sm={12} xs={12}>
              <Form.Label>نام بخش:</Form.Label>
              <Form.Select
                type="text"
                value={formSupport.sectionSupport}
                name="sectionSupport"
                onChange={e =>
                  setFieldSupport("sectionSupport", e.target.value)
                }
              >
                <option value="پشتیبانی">پشتیبانی</option>
                <option value="امور نمایندگان">امور نمایندگان</option>
                <option value="مالی و حسابداری">مالی و حسابداری</option>
                <option value="انفورماتیک">انفورماتیک</option>
                <option value="مدیریت">مدیریت</option>
              </Form.Select>
            </Col>
          </Row>

          <Row className="mt-1">
            <Col lg={4} sm={6} xs={12}>
              <Form.Label>نوع تیکت:</Form.Label>
              <Form.Select
                type="text"
                name="typeSupport"
                value={formSupport.typeSupport}
                onChange={e => {
                  setFieldSupport("typeSupport", e.target.value);
                  setGetValue(e.target.value);
                }}
              >
                <option value="سفارش خاص">مربوط به یک سفارش</option>
                <option value="سایر">سایر</option>
              </Form.Select>
            </Col>

            {getValue === "سفارش خاص" && (
              <Col xs={12} sm={6} lg={4} xl={3} className="mt-2">
                <label className="m-0">شماره سفارش:</label>
                <div>
                  <Form.Control
                    type="number"
                    name="barnameSupport"
                    value={formSupport.barnameSupport}
                    onChange={e =>
                      setFieldSupport("barnameSupport", e.target.value)
                    }
                    isInvalid={!!errorsSupport.barnameSupport}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errorsSupport.barnameSupport}
                  </Form.Control.Feedback>
                </div>
              </Col>
            )}
          </Row>

          <Row className="mt-1">
            <Col lg={9} md={9} sm={9} xs={12}>
              <Form.Label>موضوع:</Form.Label>
              <Form.Control
                type="text"
                name="subjectSupport"
                value={formSupport.subjectSupport}
                onChange={e =>
                  setFieldSupport("subjectSupport", e.target.value)
                }
                isInvalid={!!errorsSupport.subjectSupport}
              />
              <Form.Control.Feedback type="invalid">
                {errorsSupport.subjectSupport}
              </Form.Control.Feedback>
            </Col>
            <Col lg={3} md={3} sm={3} xs={12}>
              <Form.Label>اولویت:</Form.Label>
              <Form.Select
                type="text"
                name="prioritySupport"
                value={formSupport.prioritySupport}
                onChange={e =>
                  setFieldSupport("prioritySupport", e.target.value)
                }
              >
                <option value="کم">کم</option>
                <option value="متوسط">متوسط</option>
                <option value="زیاد">زیاد</option>
                <option value="اضطراری">اضطراری</option>
              </Form.Select>
            </Col>
          </Row>

          <div className="mt-1">
            <Form.Label>شرح:</Form.Label>
            <Form.Control
              as="textarea"
              type="text"
              name="descSupport"
              className="form-control"
              value={formSupport.descSupport}
              maxLength={2000}
              onChange={e => setFieldSupport("descSupport", e.target.value)}
              isInvalid={!!errorsSupport.descSupport}
            />
            <small className="text-secondary">حداکثر 2000 کاراکتر</small>
            <Form.Control.Feedback type="invalid">
              {errorsSupport.descSupport}
            </Form.Control.Feedback>
          </div>
        </Form.Group>

        <div className="d-flex align-items-center justify-content-center mt-4">
          {loading ? (
            <button className="btn-success-style" type="button" disabled>
              <span
                className="spinner-border spinner-border-sm ml-2"
                role="status"
                aria-hidden="true"
              ></span>
              منتظر بمانید...
            </button>
          ) : (
            <button type="submit" className="btn-success-style">
              ارسال
            </button>
          )}
        </div>
      </Form>
    </div>
  );
}

export default NewTicket;
